/**
 * Shared React Query key factory for market-entity queries (events/series by ticker).
 *
 * Kept in a standalone, server-safe module (no React hooks, no browser APIs) so both
 * client hooks (`queries/markets.ts`) and server-side seed utilities
 * (`queries/marketEntitySeed.ts`, `prefetchEventPageQueries.ts`) can import the same
 * constants without pulling client-only code into the Node.js render path. Mirrors
 * `liveDataKeys.ts`/`milestoneKeys.ts`.
 *
 * ⚠️ Do NOT add browser-only or React-hook imports to this file.
 */
export const marketEntityKeys = {
    all: ['marketEntities'] as const,
    eventsByTickers: (tickers: string[]) => [...marketEntityKeys.all, 'events', [...tickers].sort()] as const,
    seriesByTickers: (tickers: string[]) => [...marketEntityKeys.all, 'series', [...tickers].sort()] as const,
    byId: (id: string) => [...marketEntityKeys.all, 'marketById', id] as const,
};
